import React, { useEffect, useState } from "react";
import TweenOne from "rc-tween-one";
import Children from "rc-tween-one/lib/plugin/ChildrenPlugin";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

import "./ProtocolStat.scss";
TweenOne.plugins.push(Children);

export default function ProtocolStat({
  title,
  value: defaultValue,
  precision,
  prefix,
  suffix,
  formatMoney,
  tooltipText,
}) {
  const [animation, setAnimation] = useState({});
  const [value, setValue] = useState(0);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    setAnimation({
      Children: {
        value: value,
        floatLength: precision,
        formatMoney: formatMoney,
      },
      duration: 1500,
    });
  }, [formatMoney, precision, value]);
  return (
    <div className="ProtocolStat">
      <div className="ProtocolStat__title">
        <Tooltip title={tooltipText}>
          <span>
            {title} <InfoCircleOutlined />
          </span>
        </Tooltip>
      </div>
      <div className="ProtocolStat__content">
        {prefix && (
          <span className="ProtocolStat__content__prefix">{prefix}</span>
        )}
        <span className="ProtocolStat__content__value">
          <TweenOne animation={animation}>0</TweenOne>
        </span>
        {suffix && (
          <span className="ProtocolStat__content__suffix">{suffix}</span>
        )}
      </div>
    </div>
  );
}
